/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { PaymentDestinationStatus } from "./PaymentDestinationStatus";
import type { StripeCheckoutSessionRedirect } from "./StripeCheckoutSessionRedirect";

/**
 * Where the FE should send the user to pay.
 *
 * ``result`` is intentionally a tagged object (not a bare URL) so future destinations —
 * e.g. a Bridge/insurance invoice page — can be added as new ``type`` variants without
 * breaking the contract. It is ``None`` only when ``status`` is ``PAID``: an already-paid
 * Checkout Session has no hosted URL to send the user to, so there is no destination to give.
 */
export interface PaymentDestinationResponse {
  result: StripeCheckoutSessionRedirect | null;
  status: PaymentDestinationStatus;
}
